import { render, staticRenderFns } from "./hfwl.vue?vue&type=template&id=0cafdf5d&scoped=true"
import script from "./hfwl.vue?vue&type=script&lang=js"
export * from "./hfwl.vue?vue&type=script&lang=js"
import style0 from "./hfwl.vue?vue&type=style&index=0&id=0cafdf5d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cafdf5d",
  null
  
)

export default component.exports